export const onOpenGtmEvent = 'basic-info';
